<style scoped>
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  background: #000;
  opacity: .3;
}

.modal-alert {
  position: fixed;
  width: 640px;
  background: #fff;
  z-index: 9;
  left: 50%;
  top: 50%;
  margin-left: -350px;
  transform: translateY(-50%);
  padding-bottom: 20px;
}

.title-close {
  height: 50px;
  border-bottom: 1px solid #D9D9D9;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  font-size: 18px;
  color: #212121;
}
.title-close div{
  height: 100%;
  line-height: 50px;
}

.personTaskSum-dialog .btns {
  width: 60px;
  height: 28px;
  background: #4FA1A4;
  border-radius: 2px;
  color: #fff;
  /* margin-top: 10px; */
  /* float: right; */
  /* margin-right: 20px; */
  line-height: 28px;
  cursor: pointer;
  font-size: 14px;
  margin: 0 auto;
}

.personTaskSum-dialog .close {
  cursor: pointer;
  color: #909399;
}

.personTaskSum-dialog .close:hover {
  color: #409EFF;
}

.personTaskSum-dialog .tips {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 4px;
  margin: 15px;
  text-align: left;
  padding: 10px 20px;
  line-height: 25px;

}

.personTaskSum-dialog .sub-title {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.personTaskSum-dialog .sub-title span {
  background: #4FA1A4;
  width: 4px;
  height: 16px;
  display: inline-block;
  margin-right: 8px;
}

.person-search {
  display: flex;
  padding-left: 30px;
  padding-top: 10px;
  align-items: center;
  color: #666;
}

.person-search .item1 {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.person-search .item1 .label {
  margin-right: 10px;
  word-break: keep-all;
}

.person-search .select-wrap {
  width: 250px;
}

/deep/.el-input-number__decrease{
  height: 33px; 
  top:3px
}
/deep/ .el-input-number__increase{
  height: 33px; 
  top:3px
}

.table-wrap {
  margin: 20px;
  margin-top: 10px;
}
.btns.cancel {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
  color:#666;
}


 .search{
  display:flex;
  align-items:center;
  padding-left:20px;

}
 .input{
  background:none;
  outline:none;
  border:none;
  width:200px;
  height:32px;
  margin:10px;
  border: 1px solid rgba(217,217,217,1);
  border-radius: 2px;
  padding-left: 10px;
}
 .search .btn{
  background: #4FA1A4;
  border-radius: 2px;
  color:#fff;
  width:60px;
  height:28px;
  line-height:28px;
  text-align: center;
  margin-left:10px;
  border:1px solid transparent ;
  cursor: pointer;
} 
.search .btn.gray{
  border:1px solid #D9D9D9 ;
  color:#212121;
  background: #fff;
}
.search-sum{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top :10px;
  padding-left :20px;
  font-size: 14px;
}


</style>
<style>
.server-task-Detail .content-main-box{
  height: auto;
}
.personTaskSum-dialog .el-dialog__body{
  padding: 0 0 10px;
}
.personTaskSum-dialog .el-dialog__header{
  padding: 0;
}


</style>
<template>
  <div class="main server-task-Detail" >
    <div class="modal" @click="close"></div>
    
    <!-- <div class="printPage"> -->
    <el-dialog
      width="641px"
      custom-class="personTaskSum-dialog"
      :visible.sync="showPrintDialog"
      :show-close="false"
      :close-on-click-modal="false"
    >
    <!-- <div class="modal-alert"> -->
      <div class="title-close">
        <div class="title"  style="margin-bottom:0">明细</div>
        <i class="el-icon-close close" @click="close"></i>
      </div>
      <div class="search-sum">
        <div class="sum">
          合计：共<span style="color:#4FA1A4;font-weight: bold;">{{detail.length }}</span>个
        </div>
       </div>
      <div class="table-wrap content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
        <el-table :data="detail" stripe border >

          <!-- <el-table-column show-overflow-tooltip label="平台任务名称" width="200" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.projectTaskName || '-' }}</template>
          </el-table-column> -->
          <el-table-column show-overflow-tooltip label="项目任务名称" width="200" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="合同任务" width="100" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.isContractTask=='Y'?'是':'否' }}</template>
          </el-table-column>
       
          <el-table-column show-overflow-tooltip label="药企报价" width="150" header-align="center" align="right">
            <template slot-scope="scope">{{ scope.row.tenantTaskPrice}}{{ scope.row.tenantTaskPriceUnit }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="业务员报价" width="150" header-align="center" align="right">
            <template slot-scope="scope">{{ scope.row.taskPrice  }}{{ scope.row.taskPriceUnit }}</template>
          </el-table-column>
        </el-table>

      </div>
      <div class="btns " @click="close">
        关闭
      </div>
      <!-- <div class="btns cancel" @click="close">
        取消
      </div> -->
    <!-- </div> -->
  </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: {
      type: Object,
      default: {},
    },
    planTitle: {
      type: String,
      default: '任务总量',
    },
    showPrintDialog: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      fullscreenLoading:false,
    };
  },
  created() {
   // this.getStaffList();
  // this.getDetailList()
  },
  methods: {
    close() {
      this.$emit('close')
    },

  


  },
};
</script>